<script lang="ts">
  let { code }: { code: string } = $props();

  let copied = $state(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(code);
      copied = true;
      setTimeout(() => {
        copied = false;
      }, 2000);
    } catch {
      console.error('Failed to copy code');
    }
  }
</script>

<div class="join-team-wrapper">
  <div class="join-team-card">
    <h2>You're invited to a Beat Duel team</h2>
    <div class="code-section">
      <p class="code-label">Team Code</p>
      <div class="code-display">{code}</div>
      <button type="button" class="btn btn-secondary" onclick={handleCopy}>
        {copied ? 'Copied!' : 'Copy Code'}
      </button>
    </div>
    <div class="info-section">
      <p class="info-text">
        Team play lives in the Beat Duel iOS app — open the app and enter this code under Crew → Join a Team.
      </p>
      <p class="info-muted">
        Don't have the app yet? Beat Duel for iPhone is in beta — ask your friend for a TestFlight invite.
      </p>
    </div>
  </div>
</div>

<style>
  .join-team-wrapper {
    display: flex;
    justify-content: center;
    padding-top: 2rem;
  }
  .join-team-card {
    max-width: 400px;
    width: 100%;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 2.5rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  .join-team-card h2 {
    text-align: center;
    color: var(--text);
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
    -webkit-text-fill-color: var(--text);
    background: none;
    background-clip: unset;
    -webkit-background-clip: unset;
  }
  .code-section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .code-label {
    font-size: 0.875rem;
    color: var(--text-muted);
    margin: 0;
  }
  .code-display {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 6px;
    padding: 1rem;
    text-align: center;
    font-family: monospace;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--text);
    letter-spacing: 0.05em;
  }
  .btn {
    padding: 0.625rem;
    font-size: 0.9375rem;
  }
  .btn-secondary {
    background: var(--bg);
    border: 1px solid var(--border);
    color: var(--text);
  }
  .btn-secondary:hover {
    background: var(--surface-hover);
  }
  .info-section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .info-text {
    font-size: 0.9375rem;
    color: var(--text);
    margin: 0;
    line-height: 1.5;
  }
  .info-muted {
    font-size: 0.875rem;
    color: var(--text-muted);
    margin: 0;
    line-height: 1.4;
  }
</style>
